export default {
  namespaced: true,
  state: () => ({
    catalogoMarca: null,
    cacheImagensPorMarca: {},
    esMarcas: [],
    filters: {
      page: 1,
      perPage: 10,
      hasMore: true,
      sortBy: null,
      sortDesc: null,
    },
    optionsCategorias: [],
    optionsReferencias: [],
    currentCatalogoMarca: {
      log_img_id: '',
      cod_marca: '',
      caminho: '',
      des_marca: '',
      usuario_id: '',
      usuario_nome: '',
      updated_at: '',
      caminho_catalogo: '',
      caminho_img_footer_principal: '',
      caminho_img_footer_secundaria: '',
      cor_cabecalho_marca: '',
      caminho_img_cabec_marcas: '',
      ordem_visualizacao: '',
    },
    imagensPorMarca: [],
  }),
  mutations: {
    SET_CATALOGO_MARCA(state, catalogo) {
      state.catalogoMarca = catalogo;
    },
    SET_IMAGENS_POR_MARCA(state, { codMarca, imagens }) {
      state.cacheImagensPorMarca[codMarca] = imagens;
    },
    setEsMarcas(state, esMarcas) {
      state.esMarcas = esMarcas;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setPage(state, payload) {
      state.filters.page = payload;
    },
    setCurrentCatalogoMarca(state, payload) {
      state.currentCatalogoMarca = payload;
    },
    setOptionsCategorias(state, payload) {
      state.optionsCategorias = payload;
    },
    setOptionsReferencias(state, payload) {
      state.optionsReferencias = payload;
    },
    setImagensPorMarca(state, payload) {
      state.imagensPorMarca = payload;
    },
  },
  getters: {
    getEsMarcas(state) {
      return state.esMarcas;
    },
    getFilters(state) {
      return state.filters;
    },
    getCurrentCatalogoMarca(state) {
      return state.currentCatalogoMarca;
    },
    getOptionsCategorias(state) {
      return state.optionsCategorias;
    },
    getOptionsReferencias(state) {
      return state.optionsReferencias;
    },
    getImagensPorMarca(state) {
      return state.imagensPorMarca;
    },
  },
  actions: {
    async listarImagensPorMarca({ commit, state }, { codMarca, params }) {
      if (state.cacheImagensPorMarca[codMarca]) {
        return state.cacheImagensPorMarca[codMarca];
      }
      const [imagens, catalogo] = await Promise.all([
        api.listarImagensPorMarca(codMarca, params),
        api.obterCatalogoMarca(codMarca),
      ]);

      commit('SET_IMAGENS_POR_MARCA', { codMarca, imagens });
      commit('SET_CATALOGO_MARCA', catalogo);

      return imagens;
    },
    async listarCatalogoMarca({ commit, state }, codMarca) {
      if (state.catalogoMarca && state.catalogoMarca.cod_marca === codMarca) {
        return state.catalogoMarca;
      }
      const catalogo = await api.obterCatalogoMarca(codMarca);
      commit('SET_CATALOGO_MARCA', catalogo);
      return catalogo;
    },
  },
};
